type ModelCarrier = {
  model?: string | null;
  instrumentModel?: string | null;
};

/** True when the model is a Vitari instrument. Same trim and case rule `telemetryLogsRoot` uses. */
export function isVitariModel(model?: string | null): boolean {
  return model?.trim().toUpperCase() === "VITARI";
}

/** S3 key root for instrument telemetry files. Vitari lands under a sibling prefix. */
export function telemetryLogsRoot(model?: string | null): string {
  return isVitariModel(model)
    ? "vitariinternallogs"
    : "avitiinternallogs";
}

/** Reads `model` or `instrumentModel` from a run or instrument payload. */
export function telemetryLogsRootFrom(source?: ModelCarrier | null): string {
  return telemetryLogsRoot(source?.model || source?.instrumentModel);
}

type FolderPart = string | String | null | undefined;

/**
 * Folder under the telemetry logs root for one instrument.
 * Vitari uploads to `<instrumentID>_<serial>_<serial>`, so its folder never depends on the display name and
 * renaming the instrument does not change where its telemetry files are looked up (SW-29899).
 * Every other model, including AVITI, keeps `<instrumentID>_<serial>_<instrumentName>`.
 * The model check is the one `telemetryLogsRoot` uses to choose the logs root.
 * Customer upload folders are separate and stay on the instrument name.
 */
export function telemetryInstrumentFolder(
  instrumentID: FolderPart,
  instrumentSerialNumber: FolderPart,
  instrumentName: FolderPart,
  model?: string | null
): string {
  const trailingSegment = isVitariModel(model)
    ? instrumentSerialNumber
    : instrumentName;
  return `${instrumentID}_${instrumentSerialNumber}_${trailingSegment}`;
}
